export default __webpack_public_path__ + "static/gdpr-compliant-bc891f89528370cfe3971a4104717940.svg";